(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('DailyNotesReportController', DailyNotesReportController);

    DailyNotesReportController.$inject = ['$window', 'common', 'dataservice', 'carousel.dialog', 'ReportFileBuilder'];
    /* @ngInject */
    function DailyNotesReportController($window, common, dataservice, carouselDialog, reportFileBuilder) {
        var vm = this;
        vm.title = 'Notes Report';
        vm.filters = {
            fromDate: new Date(),
            toDate: new Date(),
            NoteTypes: []
        };
        vm.filterData = {
            NoteTypes: []
        };
        vm.items = [];
        vm.displayedItems = [].concat(vm.items);
        vm.forDateOpen = false;
        vm.openDatePicker = openDatePicker;
        vm.generate = generate;
        vm.showAttachment = showAttachment;
        vm.openDatePicker = openDatePicker;
        vm.exportToExcel = exportToExcel;
        vm.exportToPdf = exportToPdf;
        vm.dpStatus = {
            fromDateOpen: false,
            toDateOpen: false
        };

        vm.generated = false;
        vm.bookingIdText = bookingIdText;
        

        activate();

        function activate() {
            vm.filterData.NoteTypes.push({ ID: 2, Description: "Task" });
            vm.filterData.NoteTypes.push({ ID: 1, Description: "Booking" });
            var promises = [];
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
            }, function (error) { });
        }

        function bookingIdText(item) {
            if (item.BookingId == 0) {
                return "";
            }
            else {
                return item.BookingId;
            }
        }

        function openDatePicker(isStart) {
            if (isStart) {
                vm.dpStatus.fromDateOpen = true;
                vm.dpStatus.toDateOpen = false;
            }
            else {
                vm.dpStatus.fromDateOpen = false;
                vm.dpStatus.toDateOpen = true;
            }

        }

        function generate() {
            vm.generated = true;
            return dataservice.query('api/NotesReport/Report', vm.filters).then(function (response) {
                vm.items = response.data;
                return vm.items;
            }, function (error) { });
        }

        function exportToExcel(id) {
            reportFileBuilder.exportToExcel("Notes Report", id, 7);
        }

       
        function exportToPdf(id) {
            reportFileBuilder.exportToPdf("Notes Report", id, vm.filters);
         }

        function showAttachment(item) {
            var parentTypeId = 0;
            if (item.BookingId > 0) {
                parentTypeId = 4;
            }
            else {
                parentTypeId = 3;
            }
                

            dataservice.getItems('api/Attachments/GetForParentType/' + parentTypeId + '/' + item.ID).then(function (response) {
                return carouselDialog.display(response.data);
            }, function (error) { });
        }
    }
})();
